<input type="time" 
[class]="class" 
[class.is-invalid]="control.touched && control.invalid"
[class.is-valid]="control.value && control.valid && showIconSuccess === true"
[class.is-loading]="control.pending && showIconSuccess === true"
[id]="id"
[name]="id"
[title]="title" 
[placeholder]="placeholder" 
[formControl]="control" />